require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconAi.tsx
var IconAi_exports = {};
__export(IconAi_exports, {
  default: () => IconAi_default
});
module.exports = __toCommonJS(IconAi_exports);

// src/assets/monochrome/ai.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgAi = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.76322 1.8176C8.95062 1.31168 9.46009 1 10 1C10.5399 1 11.0494 1.31168 11.2368 1.8176L13.2324 7.20502L18.1407 8.86175C18.6382 9.02968 19 9.47217 19 10C19 10.5278 18.6382 10.9703 18.1407 11.1382L13.2324 12.795L11.2368 18.1824C11.0494 18.6883 10.5399 19 10 19C9.46009 19 8.95062 18.6883 8.76322 18.1824L6.76758 12.795L1.85933 11.1382C1.36181 10.9703 1 10.5278 1 10C1 9.47217 1.36181 9.02968 1.85933 8.86175L6.76758 7.20502L8.76322 1.8176ZM10 4.07042L8.53157 8.03461C8.36421 8.48639 8.00175 8.83841 7.54527 8.99249L4.56042 10L7.54527 11.0075C8.00175 11.1616 8.36422 11.5136 8.53157 11.9654L10 15.9296L11.4684 11.9654C11.6358 11.5136 11.9982 11.1616 12.4547 11.0075L15.4396 10L12.4547 8.99249C11.9982 8.83841 11.6358 8.48639 11.4684 8.03461L10 4.07042ZM16.1218 2.46795C16.1218 2.11392 15.8348 1.82692 15.4808 1.82692C15.1267 1.82692 14.8398 2.11392 14.8398 2.46795C14.8398 2.82198 14.5528 3.10897 14.1987 3.10897C13.8447 3.10897 13.5577 3.39597 13.5577 3.75C13.5577 4.10403 13.8447 4.39103 14.1987 4.39103C14.5528 4.39103 14.8398 4.67802 14.8398 5.03205C14.8398 5.38608 15.1267 5.67308 15.4808 5.67308C15.8348 5.67308 16.1218 5.38608 16.1218 5.03205C16.1218 4.67802 16.4088 4.39103 16.7628 4.39103C17.1169 4.39103 17.4039 4.10403 17.4039 3.75C17.4039 3.39597 17.1169 3.10897 16.7628 3.10897C16.4088 3.10897 16.1218 2.82198 16.1218 2.46795Z", fill: "#676F7E" }) });
var ai_default = SvgAi;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconAi.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconAi = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(ai_default, {}) });
};
IconAi.displayName = "IconAi";
var IconAi_default = IconAi;
